<template>
  <div class="">
    <div class="text-lg font-bold">
      ข้อมูลการจัดส่ง
    </div>
    <!-- วันที่จัดส่ง -->
    <div class="flex flex-row lg:flex-col justify-between mt-2 lg:mt-0">
      <label class="form-label font-bold">วันที่จัดส่ง:</label>
      <div>{{ shipping.date }}</div>
    </div>
    <!-- สถานที่รับส่ง -->
    <div class="flex flex-row lg:flex-col justify-between">
      <label class="form-label font-bold">สถานที่รับส่ง:</label>
      <div>{{ shipping.address }}</div>
    </div>
    <!-- ผู้รับสินค้า -->
    <div class="flex flex-row lg:flex-col justify-between">
      <label class="form-label font-bold">ผู้รับสินค้า:</label>
      <div>{{ shipping.recipient }}</div>
    </div>
    <!-- เงื่อนไขการส่งสินค้า -->
    <div class="flex flex-row lg:flex-col justify-between">
      <label class="form-label font-bold">เงื่อนไขการส่งสินค้า:</label>
      <div>{{ shipping.conditionSend }}</div>
    </div>
    <!-- เงื่อนไขการจ่ายเงิน -->
    <div class="flex flex-row lg:flex-col justify-between">
      <label class="form-label font-bold">เงื่อนไขการจ่ายเงิน:</label>
      <div>{{ shipping.conditionPayment }}</div>
    </div>
    <!-- ผู้สร้างเอกสารตรวจรับ -->
    <div class="flex flex-row lg:flex-col justify-between">
      <label class="form-label font-bold">ผู้สร้างเอกสารตรวจรับ:</label>
      <div>{{ shipping.checkBy }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue'

export default defineComponent({
  name: 'detail-shipping',
  props: {
    shipping: {
      type: Object,
      default: () => {
        return {
          date: '',
          address: '',
          recipient: '',
          conditionSend: '',
          conditionPayment: '',
          checkBy: ''
        }
      }
    }
  },
  setup(props) {
    return {
      ...toRefs(props)
    }
  }
})
</script>

<style scoped></style>
